import { writable } from 'svelte/store';

export type ToastType = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
  supportReference?: string;
}

const { subscribe, update } = writable<Toast[]>([]);
let nextId = 1;

function remove(id: number): void {
  update(toasts => toasts.filter(toast => toast.id !== id));
}

function add(message: string, type: ToastType = 'info', duration = 4500, supportReference?: string): number {
  const id = nextId++;
  update(toasts => [...toasts, { id, message, type, ...(supportReference ? { supportReference } : {}) }]);
  if (duration > 0) setTimeout(() => remove(id), duration);
  return id;
}

export const toastStore = {
  subscribe,
  add,
  remove,
  success: (message: string, duration?: number): number => add(message, 'success', duration),
  error: (message: string, duration?: number): number => add(message, 'error', duration),
  supportReference: (requestId: string, userMessage?: string): number | null => {
    if (!/^[A-Za-z0-9][A-Za-z0-9._:-]{0,63}$/.test(requestId)) return null;
    return add(userMessage ?? 'Une erreur serveur est survenue. Transmets cette référence au support.', 'error', 12000, requestId);
  },
  info: (message: string, duration?: number): number => add(message, 'info', duration)
};
